import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { BASE_APIGEE_URL, GIS_URL_PATH } from '@constants/urls';
import { environment } from '@environments/environment';

/*
 * Intercept all requests bound for Apigee
 * - Allow overriding the Authorization header if manually passed in
 * - Otherwise, attach the OIDC SSO token
 * - Attach required Apigee headers
 */
export const ApigeeInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes(BASE_APIGEE_URL)) return next(req);

  const oidcSecurityService = inject(OidcSecurityService);
  const hasCustomAuth = req.headers.has('Authorization');
  const tokenObservable = hasCustomAuth ? of('') : oidcSecurityService.getAccessToken();

  return tokenObservable.pipe(
    switchMap((ssoToken: string) => {
      if (!hasCustomAuth && !ssoToken) {
        throw new Error('No custom auth header or SSO token available for authenticated request');
      }

      let clonedRequest;

      if (req.url.includes(GIS_URL_PATH)) {
        clonedRequest = req.clone({
          setHeaders: {
            ...(!hasCustomAuth && { Authorization: `Bearer ${ssoToken}` }),
            client_id: environment.DEV_PORTAL_APP_CONSUMER_KEY_FRONTEND,
            'X-NW-Message-ID': crypto.randomUUID(),
          },
        });
      } else {
        clonedRequest = req.clone({
          setHeaders: {
            ...(!hasCustomAuth && { Authorization: `Bearer ${ssoToken}` }),
            client_id: environment.DEV_PORTAL_APP_CONSUMER_KEY_FRONTEND,
            'target-env': 'home-service-contract',
            'x-api-key': environment.API_GATEWAY_KEY,
            'X-NW-Message-ID': crypto.randomUUID(),
          },
        });
      }

      return next(clonedRequest);
    }),
  );
};
